import { getFile, objectToQueryParams } from '@si/utils';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

interface Params {
  projectId: string;
  filepath: string;
}

export function useDownloadProjectFile() {
  const { mutate, error, isPending, isSuccess, reset, variables } = useMutation<
    void,
    Error,
    Params
  >({
    mutationFn: ({ projectId, filepath }: Params) =>
      getFile({
        url: `/projects/${projectId}/documentation/download${objectToQueryParams({
          filepath,
        })}`,
      }),
  });

  const download = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    download,
    error,
    isPending,
    isSuccess,
    reset,
    variables,
  };
}
